export default "__VITE_ASSET__9ffd1d51__"